var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "52.441%",
    cy: "50%",
    fx: "52.441%",
    fy: "50%",
    r: "64.439%",
    id: "uyzxjcuu8a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCECE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "8.022%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "g9z7e18tyb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989898",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#uyzxjcuu8a)",
    width: 32,
    height: 32,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.027 17.771c-1.215 0-2.247-.424-3.096-1.274-.85-.849-1.274-1.881-1.274-3.096V5.406a1.829 1.829 0 0 1-1.18-.611A1.808 1.808 0 0 1 0 3.542V1.885C0 1.374.186.932.56.559.931.186 1.373 0 1.884 0h8.285c.51 0 .953.186 1.325.56.373.372.56.814.56 1.325v1.657c0 .483-.16.9-.477 1.253a1.829 1.829 0 0 1-1.18.61v7.996c0 1.215-.428 2.247-1.285 3.096-.856.85-1.884 1.274-3.086 1.274zm0-1.553c.663 0 1.243-.2 1.74-.6.497-.401.822-.912.974-1.534H6.649a.744.744 0 0 1-.767-.766.78.78 0 0 1 .218-.56.727.727 0 0 1 .549-.227h2.195v-1.243H6.65a.727.727 0 0 1-.55-.228.754.754 0 0 1-.217-.538.77.77 0 0 1 .218-.57.744.744 0 0 1 .549-.217h2.195V8.492H6.65a.727.727 0 0 1-.55-.228.78.78 0 0 1-.217-.559.744.744 0 0 1 .767-.766h2.195V5.427H3.231V13.4c0 .787.273 1.453.818 1.999a2.695 2.695 0 0 0 1.978.818z",
    transform: "translate(10 7)",
    fill: "url(#g9z7e18tyb)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrey);
export default __webpack_public_path__ + "static/media/grey.5f8855d10a35ff536d57b454bbcb2820.svg";
export { ForwardRef as ReactComponent };